module.exports = __webpack_public_path__ + "media/icons/search-1a6d4e06.svg";